import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import Layout from '~/components/Layout';
import TableComponent from '~/components/TableComponent';
import { FarmersQuery } from '~/QueryHooks/Farmers';

const MonthlyContracts: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 10
  })

  const tableColumnHeaders = [
    {
      name: t('Year'),
      key: 'year'
    },
    {
      name: t('Amount'),
      key: 'amount'
    }
  ]

  const {
    data: monthlyContractAmounts,
    isLoading: isLoading,
    isFetching: isFetchingData,
    refetch: fetchData
  } = FarmersQuery.getMonthlyContractAmounts(id, {
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  })

  useEffect(() => {
    fetchData()
  }, [dataFiltered])

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={tableColumnHeaders}
      animated
      isFetchingData={isFetchingData}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      rows={rows}
      total={filtered}
    />
  }

  const { filtered, rows } = monthlyContractAmounts ? monthlyContractAmounts : { filtered: 0, rows: [] };

  return <Layout
    childContainerSize={'auto'}
    isBusy={isLoading}
    useSpinner
    title={t('')}>
    {renderTable()}
  </Layout>;
}
export default MonthlyContracts